import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faVanShuttle, faSteeringWheel } from '@fortawesome/pro-regular-svg-icons';

// Type-safe tab ID union
export type TransportationTabId = 'services' | 'vehicles';

// Tab interface
export interface TransportationTab {
    id: TransportationTabId;
    name: string;
    icon: IconDefinition;
}

// Individual tab definitions
export const servicesTab: TransportationTab = {
    id: 'services',
    name: 'Services',
    icon: faVanShuttle
};

export const vehiclesTab: TransportationTab = {
    id: 'vehicles',
    name: 'Vehicles',
    icon: faSteeringWheel
};

// Export array for iteration
export const transportationTabs = [servicesTab, vehiclesTab];
